// Grouped client for Generic operations
import { ApiConfiguration } from '../ApiConfiguration';
import { ReferenceValue } from '../models/ReferenceValue';
import { AugmentedTag } from '../models/AugmentedTag';
import { FilterRequest } from '../models/FilterRequest';
import { ReferenceValueSerializer } from '../serializers/ReferenceValueSerializer';
import { AugmentedTagSerializer } from '../serializers/AugmentedTagSerializer';
import { FilterRequestSerializer } from '../serializers/FilterRequestSerializer';

/**
 * HTTP client for Generic operations
 *
 * Client for Generic operations
 */
export class GenericClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getTagsForObject(objectType: string, partialTag?: string | null, options?: { headers?: Record<string, string> }): Promise<AugmentedTag[]> {
    let path = '/app/api/Object/{objectType}/Tags'
      .replace('{objectType}', encodeURIComponent(String(objectType)))
      ;

    const queryParams = new URLSearchParams();
    if (partialTag !== undefined) {
      queryParams.append('partialTag', String(partialTag));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => AugmentedTagSerializer.fromObject(item));
  }

  async getReferenceValues(objectType: string, request?: FilterRequest | null, options?: { headers?: Record<string, string> }): Promise<ReferenceValue[]> {
    let path = '/app/api/Object/{objectType}/Lookup'
      .replace('{objectType}', encodeURIComponent(String(objectType)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ReferenceValueSerializer.fromObject(item));
  }

  async getReferenceValuesWithField(objectType: string, fieldName: string, request?: FilterRequest | null, options?: { headers?: Record<string, string> }): Promise<ReferenceValue[]> {
    let path = '/app/api/Object/{objectType}/Lookup({fieldName})'
      .replace('{objectType}', encodeURIComponent(String(objectType)))
      .replace('{fieldName}', encodeURIComponent(String(fieldName)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ReferenceValueSerializer.fromObject(item));
  }

}
